import {
    USUARI_INICIALITZAR,
    USUARI_OBTENIR_USUARIS_EN_CURS,
    USUARI_OBTENIR_USUARIS_FINALITZADA
} from '../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioUsuarisEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_OBTENIR_USUARIS_EN_CURS:
            return true;

        case USUARI_OBTENIR_USUARIS_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default peticioUsuarisEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/usuari/peticioUsuarisEnCurs.js